import * as React from "react";
import { WithNamespaces, withNamespaces } from "react-i18next";
import {
  ProposalPOV,
  ResponseTypes,
  PayloadPov,
  GenericalResponse
} from "src/redux/projects";
import fscreen from "fscreen";
import { ImagePanWithPin } from "./ImagePanWithPin";
import ControlBar, { ControlBarEvents } from "./ControlBar";
import PovSidebar from "./PovSidebar";
import { NoPrint, Print } from "react-easy-print";
import { downloadUrl } from "src/helpers/downloadUrl";
import { CurrentResponse } from "src/redux/currentResponses";
import { toast } from "react-toastify";
import { Profil } from "src/redux/user";
import { shareProposalWithModal } from "src/helpers/shareProposalWithModal";

interface Props {
  proposal: ProposalPOV;
  response: CurrentResponse | undefined;
  isLocked: boolean;
  prestationName: string;
  projectName: string;
  profil: Profil;
  setCurrentProposalResponseForPov: (
    proposalUuid: string,
    ressourceId: number,
    comment: string
  ) => void;
  setCurrentProposalResponseType: (
    proposalUuid: string,
    responseType: ResponseTypes
  ) => void;

  handleSubmitProposal: (response: GenericalResponse | undefined) => void;
}

interface State {
  // image zoom
  imageZoom: number;
  currentId: number;
  step: number;
}
type PropsWithNamespaces = Props & WithNamespaces;

class PovPage extends React.Component<PropsWithNamespaces, State> {
  fullscreenDiv = React.createRef<any>();

  state = {
    step: 0,
    imageZoom: 0.5,
    currentId: this.props.proposal.responses
      ? this.props.proposal.responses[0].ressourceId
      : 0
  };
  componentWillMount() {
    if (
      this.props.proposal.responses &&
      this.props.proposal.responses[0].ressourceId > 2
    ) {
      toast.error(this.props.t("proposal.pov.povNotExist"));
      this.setState({
        currentId: 0
      });
    }
  }
  controlBarHandler = (type: ControlBarEvents, data: any) => {
    switch (type) {
      case ControlBarEvents.ToggleFullScreen:
        this.setState({ imageZoom: 1 }, () => this.toggleFullScreen());
        break;
      case ControlBarEvents.Print:
        window.print();
        break;
      case ControlBarEvents.Download:
        downloadUrl(
          this.props.proposal.ressources[this.state.currentId].image,
          this.props.proposal.ressources[this.state.currentId].label
        );
        break;
      case ControlBarEvents.Share:
        shareProposalWithModal(this.props.proposal);
        break;
      case ControlBarEvents.ZoomIn:
        this.setState({ imageZoom: Math.max(this.state.imageZoom + 0.2, 0) });
        break;
      case ControlBarEvents.ZoomOut:
        this.setState({ imageZoom: Math.max(this.state.imageZoom - 0.2, 0) });
        break;
    }
  };

  handleChangePov = ressourceId => {
    this.setState({
      currentId: ressourceId
    });
    this.props.setCurrentProposalResponseForPov(
      this.props.proposal.uuid,
      ressourceId,
      this.props.response && this.props.response.response
        ? (this.props.response.response.payload as PayloadPov).comment
        : ""
    );
  };

  /**
   * Toggle full screen for image element
   */
  toggleFullScreen() {
    if (fscreen.fullscreenElement === null) {
      fscreen.requestFullscreen(this.fullscreenDiv.current);
    } else {
      fscreen.exitFullscreen();
    }
  }

  /**
   * Once image has loaded, we calculate first zoom so the whole image fits in pan div
   */
  onImageLoaded = (image: HTMLImageElement) => {
    const fittingZoom =
      this.fullscreenDiv.current.offsetHeight / image.offsetHeight;
    this.setState({ imageZoom: fittingZoom - 0.1 });
  };

  onChangeStep = (value: number) => {
    this.setState({
      step: value
    });
  };
  render() {
    return (
      <div className="proposal">
        <div className="d-flex">
          <NoPrint force={true}>
            <div className="proposal-screen">
              <div ref={this.fullscreenDiv}>
                <ImagePanWithPin
                  url={
                    this.props.proposal.ressources[this.state.currentId]
                      ? this.props.proposal.ressources[this.state.currentId]
                          .image
                      : "null"
                  }
                  comments={[]}
                  zoom={this.state.imageZoom}
                  onImageLoad={this.onImageLoaded}
                  locked={this.props.isLocked}
                />
              </div>
              <div className="flex-1 d-flex align-items-center justify-content-center">
                <ControlBar
                  onEvent={this.controlBarHandler}
                  buttons={["fscreen", "zoom", "download", "print", "share"]}
                />
              </div>
            </div>
          </NoPrint>
          <Print printOnly={true} name="artwork-comments">
            <img
              src={
                this.props.proposal.ressources[this.state.currentId]
                  ? this.props.proposal.ressources[this.state.currentId].image
                  : "null"
              }
            />
          </Print>
          <NoPrint force={true}>
            <PovSidebar
              handleChangePov={this.handleChangePov}
              currentId={this.state.currentId}
              isLocked={this.props.isLocked}
              setCurrentProposalResponseForPov={
                this.props.setCurrentProposalResponseForPov
              }
              proposal={this.props.proposal}
              setCurrentProposalResponseType={
                this.props.setCurrentProposalResponseType
              }
              onChangeStep={this.onChangeStep}
              step={this.state.step}
              response={this.props.response}
              handleSubmitProposal={this.props.handleSubmitProposal}
            />
          </NoPrint>
        </div>
      </div>
    );
  }
}

export default withNamespaces()(PovPage);



// WEBPACK FOOTER //
// ./src/components/Pov.tsx